import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosHttp from "services/axiosHttp";

export const getTenders = createAsyncThunk("getTenders", async ({ page, limit }, { rejectWithValue }) => {
     try {

          const queryParams = new URLSearchParams({
               page: page,
               limit: limit,
          });
          console.log("Query Params for getTenders API:", queryParams.toString());
          const response = await axiosHttp.get(`tms/tenders?${queryParams}`);
          console.log("Response from getTenders API:", response.data);
          return response.data;

     } catch (err) {
          if (!err.response) throw err;
          return rejectWithValue(err.response.data);
     }
});

export const getTenderStatusList = createAsyncThunk("getTenderStatusList", async (_, { rejectWithValue }) => {
     try {
          const response = await axiosHttp.get("status/list?identifier=tenders");
          return response?.data?.data || [];
     } catch (err) {
          if (!err.response) throw err;
          return rejectWithValue(err.response.data);
     }
});

const TendersSlice = createSlice({
     name: "TendersSlice",
     initialState: {
          isLoading: false,
          data: null,
          error: null,
          page: 1,
          total: 0,
     },

     reducers: {},

     extraReducers: (builder) => {
          // getTenders
          builder.addCase(getTenders.pending, (state) => {
               state.isLoading = true;
          });
          builder.addCase(getTenders.fulfilled, (state, action) => {
               state.isLoading = false;
               state.data = action.payload?.data;
               state.page = action.payload?.data?.pagination?.page || 1;
               state.total = action.payload?.data?.pagination?.total || 0;
          });
          builder.addCase(getTenders.rejected, (state, action) => {
               state.isLoading = false;
               state.error = action.payload;
          });

          //status
          builder.addCase(getTenderStatusList.pending, (state) => {
               state.statusLoading = true;
          });
          builder.addCase(getTenderStatusList.fulfilled, (state, action) => {
               state.statusLoading = false;
               state.status = action.payload;
          });
          builder.addCase(getTenderStatusList.rejected, (state, action) => {
               state.statusLoading = false;
               state.statusError = action.payload;
          });
     },
});

export const { resetTenders } = TendersSlice.actions;
export const { resetTenderStatus } = TendersSlice.actions;
export default TendersSlice.reducer;